import {
  getStoreList,
  pathCreateStore,
  getStoreFormExtendedList,
  getStoreFormList,
  pathChangeStoreCustomer,
  pathChangeTypeCustomer,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { storeActions } from "../reducers/store";
import { toast } from "react-toastify";
import { t } from "i18next";
import { fetchCustomerList } from "./customer";

export const fetchStoreList = (id_store = 0) => {
  return (dispatch) => {
    return apiService
      .get(getStoreList(id_store))
      .then((response) => {
        id_store == 0
          ? dispatch(storeActions.fetchStoreList(response.data))
          : dispatch(storeActions.fetchStoreDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchStoreFormExtendedList = (id_store = 0) => {
  return (dispatch) => {
    return apiService
      .get(getStoreFormExtendedList(id_store))
      .then((response) => {
        dispatch(storeActions.fetchStoreFormExtendedList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchStoreFormList = (companyId) => {
  return (dispatch) => {
    return apiService
      .get(getStoreFormList(companyId))
      .then((response) => {
        dispatch(storeActions.fetchStoreFormList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchStoreFormListClear = () => {
  return (dispatch) => {
    dispatch(storeActions.fetchStoreFormListClear());
  };
};

export const clearStoreDetail = () => {
  return (dispatch) => {
    dispatch(storeActions.fetchStoreDetail([]));
  };
};

export const createNewStore = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .post(pathCreateStore(), data)
      .then((response) => {
        // dispatch(storeActions.fetchStoreList(response.data));
        navigate("/store-list");
        toast.success(t("storesListActions.created"), {
          theme: "colored",
        });
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchEditStore = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .put(pathCreateStore(), data)
      .then((response) => {
        // dispatch(storeActions.fetchStoreList(response.data));
        toast.success(t("storesListActions.updated"), {
          theme: "colored",
        });
        navigate("/store-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchChangeStoreCustomer = (data) => {
  return (dispatch) => {
    return apiService
      .put(pathChangeStoreCustomer(), data)
      .then((response) => {
        // dispatch(storeActions.fetchStoreList(response.data));
        toast.success("Uspesno ste zamenili radnju.", {
          theme: "colored",
        });
        dispatch(fetchCustomerList());
        // navigate("/store-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchChangeTypeCustomer = (data) => {
  return (dispatch) => {
    return apiService
      .put(pathChangeTypeCustomer(), data)
      .then((response) => {
        // dispatch(storeActions.fetchStoreList(response.data));
        toast.success("Uspesno ste zamenili radnju.", {
          theme: "colored",
        });
        dispatch(fetchCustomerList());
        // navigate("/store-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("actions.error.refreshPage") + err.response, {
      theme: "colored",
    });
  }
  toast.error(errorMessage, { theme: "colored" });
};
